import * as React from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
} from '@mui/material';
import { ArrowRightAlt, ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import PropTypes from 'prop-types';
import RoutePaths from '../../configs/Routes';
import Activity1 from '../../assets/images/activities_1.jpg';
import Activity2 from '../../assets/images/activities_2.jpg';
import Activity3 from '../../assets/images/activities_3.png';
import Activity4 from '../../assets/images/activities_4.png';

export function ActivityCard({ title, applyInventoryFilter, imgSrc, body }) {
  return (
    <Box
      sx={{
        minWidth: { xs: '85%', sm: '60%', md: '45%', lg: '25%' },
        maxWidth: 360,
        flexShrink: 0,
        p: 2,
      }}
    >
      <Box
        component="img"
        src={imgSrc}
        alt={title}
        sx={{
          width: '100%',
          height: 240,
          objectFit: 'cover',
          borderRadius: 3,
        }}
      />
      <Box mt={2}>
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 0.5, mb: 1.5 }}
        >
          {body}
        </Typography>
        <Button
          variant="text"
          sx={{
            color: '#FF6B00',
            fontWeight: 500,
            textTransform: 'none',
            p: 0,
            minWidth: 0,
            border: '1px solid #FF6B00',
            px: 1.5,
            py: 0.5,
            borderRadius: 10,
            ":hover": { backgroundColor: '#FF6B00', color: 'white' }
          }}
          onClick={() => {
            const queryParams = new URLSearchParams({
              filter: [applyInventoryFilter],
            });
            window.open(`${RoutePaths.INVENTORY}?${queryParams.toString()}`, '_blank');
          }}
        >
          Learn more
        </Button>
      </Box>
    </Box>
  );
}

ActivityCard.propTypes = {
  title: PropTypes.string.isRequired,
  applyInventoryFilter: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

const Activities = () => {
  const activities = [
    {
      title: 'Saona Island',
      applyInventoryFilter: 'Saona Islands,Saona Island Tour',
      imgSrc: Activity1,
      body: 'Unwind in paradise with a Saona Island Tour in Punta Cana - pristine beaches, crystal clear waters, and breathtaking scenery.',
    },
    {
      title: 'Snorkeling',
      applyInventoryFilter: 'Snorkeling',
      imgSrc: Activity2,
      body: 'Explore the vibrant underwater world of Punta Cana while snorkeling, encountering colorful marine life and coral reefs in crystal clear waters.',
    },
    {
      title: 'Ziplining',
      applyInventoryFilter: 'Zipline',
      imgSrc: Activity3,
      body: 'Get your adrenaline pumping with our Zip lining activity in Punta Cana - an adventure through the treetops.',
    },
    {
      title: 'Buggy Rides',
      applyInventoryFilter: 'Buggy Ride',
      imgSrc: Activity4,
      body: 'Experience the thrill of off-road adventure in Punta Cana by driving a buggy through rugged terrain and scenic countryside.',
    },
  ];

  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.offsetWidth * 0.8;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box sx={{ backgroundColor: '#FFE5D0', py: 6, px: { xs: 2, sm: 4, md: 10, lg: 20 } }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography
          variant="h5"
          fontWeight="600"
          fontSize={{ xs: '1.2rem', md: '1.5rem' }}
        >
          Some of Our Popular Activities
        </Typography>
        <Box>
          <IconButton sx={{ color: '#FF6B00' }} onClick={() => scroll('left')}>
            <ArrowBackIos fontSize="small" />
          </IconButton>
          <IconButton sx={{ color: '#FF6B00' }} onClick={() => scroll('right')}>
            <ArrowForwardIos fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <Box
        ref={scrollRef}
        sx={{
          display: 'flex',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {activities.map((a, index) => (
          <ActivityCard {...a} key={index} />
        ))}
      </Box>

      <Box display="flex" justifyContent="start" mt={4}>
        <Button
          variant="outlined"
          endIcon={<ArrowRightAlt />}
          onClick={() => window.open(RoutePaths.INVENTORY, '_blank')}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: '24px',
            fontWeight: 600,
            borderColor: 'black',
            color: 'black',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#000',
              color: '#fff',
              borderColor: '#000',
            },
          }}
        >
          View All Excursions
        </Button>
      </Box>
    </Box>
  );
};

export default Activities;
